import * as React from 'react';
import { composer } from '../../../component-decorators/composer';
import { config } from '../../../config';
import { PreviewMode } from './preview-context';
import type { WithTranslation as WithTranslationProps } from 'react-i18next';
import { Text, Box, Heading } from '@wix/design-system';

export interface IReviewsPreivewWrapperProps
  extends Partial<WithTranslationProps> {
  children: React.ReactNode;
}
export const ReviewsPreivewWrapper = composer()
  .withTranslation()
  .compose((props: IReviewsPreivewWrapperProps) => {
    return (
      <PreviewMode.Consumer>
        {(value) => {
          return value.isPreview ? (
            <div>
              <Box direction="vertical" paddingTop="54px">
                <Heading appearance="H2">
                  {props.t('solution.page.noReviewsYetTitle')}
                </Heading>
                <Text>
                  {props.t('solution.page.preview.reviewsEmptyState')}
                </Text>
              </Box>

              <img
                style={{ marginTop: '42px' }}
                src={`${config.marketplaceStaticsUrl}assets/images/preview-page/empty-reviews-1x.png`}
              />
            </div>
          ) : (
            <div>{props.children}</div>
          );
        }}
      </PreviewMode.Consumer>
    );
  });
